<template>
  <div class="configuration-list p-2 page page-with-table">
    <page-header class="mb-2" :title="$t('Sales Tax Configuration')"/>
    <div class="card content-wrapper">
      <states-table/>
    </div>
    <state-modal/>
    <county-modal/>
    <city-modal/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import PageHeader from "../../../core/components/page-header/PageHeader";
  import AddNewButton from "../../../core/components/common/AddNewButton";
  import StatesTable from "./StatesTable";
  import StateModal from "./StateModal";
  import CountyModal from "./CountyModal";
  import CityModal from "./CityModal";

  const {mapActions} = createNamespacedHelpers('setup/salesTaxConfiguration');
  const {mapState} = createNamespacedHelpers('global');
  export default {
    name: "SalesTaxConfiguration",
    components: {CityModal, CountyModal, StateModal, StatesTable, AddNewButton, PageHeader},
    computed: {
      ...mapState(['currentBranch', 'isSalesTaxEnabled']),
    },
    methods: {
      ...mapActions(['updateTableSource', 'getAllState']),
    },
    async beforeMount() {
      if (this.isSalesTaxEnabled) {
        const countryCode = this.currentBranch.country_code;
        await this.updateTableSource({extraFilters: {country_code: countryCode}});
        await this.getAllState({load_all: true, country_code: countryCode});
      } else if (this.$route.path === '/sales-tax-configuration') {
        this.loadTable = false;
        await this.$router.push({name: 'not-found'});
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "./scss/variables";

  .configuration-list {
    @include list-view-wrapper;
  }
</style>